import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ArrowsCursor = props => {
  const { changeIndexDoc, currentIndex } = props;
  const navigate = useNavigate();
  const documentsWithSearch = useSelector(state => state.documentsWithSearch);
  return (
    <div style={{ display: "flex" }}>
      <div style={{ marginRight: "20px", width: "46px" }}>
        {currentIndex > 0 && (
          <Button
            onClick={e => {
              changeIndexDoc(currentIndex - 1);
              navigate("/dettaglio-documento/" +
                  documentsWithSearch.results.list[currentIndex - 1].documentId);
            }}
          >
            <FontAwesomeIcon icon={["far", "arrow-left"]} />
          </Button>
        )}
      </div>
      <div style={{ width: "46px" }}>
        {(documentsWithSearch.results.list &&
          currentIndex < documentsWithSearch.results.list.length - 1) ||
        (typeof documentsWithSearch.links !== "undefined" &&
          documentsWithSearch.links !== null) ? (
            <Button
              onClick={e => {
                changeIndexDoc(currentIndex + 1);
                navigate("/dettaglio-documento/" +
                  documentsWithSearch.results.list[currentIndex + 1].documentId);
              }}
            >
              <FontAwesomeIcon icon={["far", "arrow-right"]} />
            </Button>
          ) : null}
      </div>
    </div>
  );
};

export default ArrowsCursor;
